var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 15.9998C11.7666 16.0002 11.5402 15.9189 11.3603 15.7698L5.36028 10.7698C5.15606 10.6 5.02763 10.3561 5.00325 10.0917C4.97888 9.82728 5.06054 9.564 5.23028 9.35979C5.40001 9.15557 5.64393 9.02715 5.90835 9.00277C6.17278 8.97839 6.43606 9.06005 6.64028 9.22979L12.0003 13.7098L17.3603 9.38979C17.4626 9.30672 17.5803 9.24469 17.7066 9.20726C17.8329 9.16983 17.9654 9.15773 18.0965 9.17167C18.2275 9.18561 18.3545 9.22531 18.4701 9.28848C18.5857 9.35166 18.6878 9.43706 18.7703 9.53979C18.8619 9.64261 18.9312 9.76324 18.974 9.89411C19.0168 10.025 19.0321 10.1633 19.019 10.3003C19.0058 10.4374 18.9645 10.5703 18.8976 10.6906C18.8307 10.811 18.7397 10.9162 18.6303 10.9998L12.6303 15.8298C12.4452 15.9553 12.2234 16.0152 12.0003 15.9998Z",
    fill: "#020209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.af736e1037de2ef0cabc6927ce2dd3a7.svg";
export { ForwardRef as ReactComponent };